export default __webpack_public_path__ + "static/media/Prestations-maintenance-reparations.0864a063.jpg";